<template>
  <v-layout column fill-height>
      <v-toolbar dense ref="aToolbar" flat>
        <v-btn text icon @click="onReload()" :title="$t('GENERIC_REFRESH')"><v-icon>mdi-refresh</v-icon></v-btn>
        <v-btn text icon @click="onCopy()" :title="$t('CONTACT_COPY_CLIPBOARD_TT')"><v-icon>mdi-clipboard-text-outline</v-icon></v-btn>
        <v-btn text icon :disabled="!activeContact.email" :href="`mailto:${activeContact.email}`" :title="$t('CONTACT_SEND_EMAIL_TT')"><v-icon>mdi-email-outline</v-icon></v-btn>
        <template v-if="contactItems.length > 1">
          <v-divider class="mx-1" inset vertical></v-divider>
          <v-btn text icon @click="onPrev()" :disabled="activeIndex <= 0"><v-icon>mdi-step-backward</v-icon></v-btn>
          <v-btn text icon @click="onNext()" :disabled="activeIndex >= contactItems.length-1"><v-icon>mdi-step-forward</v-icon></v-btn>
          <v-divider class="mx-1" inset vertical></v-divider>
          <v-checkbox hide-details :label="$t('CONTACT_BROWSE_MARKED')" v-model="marked"></v-checkbox>
        </template>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn text color="primary" @click="onSave()"><v-icon>mdi-account-check-outline</v-icon>&nbsp;{{ $t('GENERIC_SAVE') }}</v-btn><br />
          <v-btn text :disabled="!activeContact.id" @click="onDuplicate()"><v-icon>mdi-content-duplicate</v-icon>&nbsp;{{ $t('CONTACT_DUPLICATE') }}</v-btn><br />
          <v-btn text color="red darken-1" :disabled="!activeContact.id" @click="onDelete()"><v-icon>mdi-trash-can-outline</v-icon>&nbsp;{{ $t('GENERIC_DELETE') }}</v-btn><br />
          <v-btn text @click="$refs.vcard.click()" :disabled="false"><v-icon>mdi-import</v-icon>&nbsp;{{ $t('CONTACT_IMPORT_VCARD') }}</v-btn><br />
          <v-btn text :disabled="!dirty" @click="onReload(true)"><v-icon>mdi-close-box-outline</v-icon>&nbsp;{{ $t('GENERIC_DISCARD') }}</v-btn><br />

<v-btn v-if="isDebug" fab small color="grey lighten-3" class="btn-debug" @click="debug=!debug"><v-icon>mdi-bug-outline</v-icon></v-btn>

        </v-toolbar-items>
      </v-toolbar>

      <!-- <v-alert type="info" :value="contact_id && contact_id !== 'new' && contact_id !== activeContact.id"> -->
      <v-alert type="info" :value="activeContact._duplicating">
        {{ $t('CONTACT_DUPLICATION_PROCESS') }}
      </v-alert>

      <v-progress-linear
        :active="loadingContactData"
        :indeterminate="loadingContactData"
        height="10"
        striped
        color="deep-orange"
      ></v-progress-linear>

      <v-sheet>
        <v-layout align-start fill-height>

          <v-flex xs1 class="text-sm-center">
            <div class="picture-wrapper" v-if="activeContactRegPhoto">
              <v-avatar @click="$refs.picture.click()" color="grey lighten-4" class="mt-1 contact-avatar">
                <img :src="activeContactRegPhoto">
              </v-avatar>
              <v-icon class="picture-remove" color="error" @click="pictureRemove()">mdi-close-circle</v-icon>
            </div>
            <v-avatar color="grey lighten-4" class="mt-1" :data-test="activeContact.genderLabel" v-else>
              <v-icon x-large v-if="activeContact.genderLabel == 0" @click="$refs.picture.click()">mdi-account-circle</v-icon>
              <img v-if="activeContact.genderLabel == 1" @click="$refs.picture.click()" :src="maleAvatar()">
              <img v-if="activeContact.genderLabel == 2" @click="$refs.picture.click()" :src="femaleAvatar()">
            </v-avatar>
          </v-flex>

          <v-flex xs11 sm6>
            <v-container class="short-info pa-2">
              <h2>{{ activeContact.title }} {{ activeContact.firstname }} {{ activeContact.lastname }}</h2>
              <p>{{ activeContact.email }}</p>
            </v-container>
          </v-flex>

          <v-flex xs12 sm5>
            <v-container class="short-info pa-2">
              <p>{{ activeContact.street }} {{ activeContact.house_no }}</p>
              <p>{{ activeContact.zipStreet }} {{ activeContact.city }}</p>
              <p>{{ activeContact.phone }}</p>
            </v-container>
          </v-flex>

        </v-layout>
      </v-sheet>

<v-sheet v-if="debug">{{ activeContact }}</v-sheet>
<!-- <v-sheet v-if="debug">{{ categories }}</v-sheet> -->

      <v-sheet>
        <v-tabs
          v-model="active"
          color="grey lighten-4"
        >
          <v-tab><div style="display: block">{{ $t('CONTACT_MAIN_DATA') }}</div>
            <!--<v-progress-linear style="display: block" :active="masterTab" indeterminate color="yellow darken-2"></v-progress-linear>-->
          </v-tab>
          <v-tab @click="show.categories=true">{{ $t('CONTACT_CATEGORIES') }}
            <!--<v-progress-linear :active="masterTab" indeterminate color="yellow darken-2"></v-progress-linear>-->
          </v-tab>
          <v-tab @click="show.customFields=true">{{ $t('CONTACT_FREE_FIELDS') }}
            <!--<v-progress-linear :active="masterTab" indeterminate color="yellow darken-2"></v-progress-linear>-->
          </v-tab>
          <v-tab>{{ $t('CONTACT_NOTES') }}
            <!--<v-progress-linear :active="masterTab" indeterminate color="yellow darken-2"></v-progress-linear>-->
          </v-tab>

          <template v-for="(custom_view, i1) in tabview">
            <v-tab :key="i1">{{ custom_view.title }}
              <!--<v-progress-linear :active="masterTab" indeterminate color="yellow darken-2"></v-progress-linear>-->
            </v-tab>
          </template>

          <!-- Master Data -->
          <v-tab-item :transition="false" :reverse-transition="false">
            <template v-if="active===0">
            <v-layout fill-height>

              <v-flex :key="i1" v-for="(column, i1) in master_data">
                <v-card class="ma-2 mb-3" :key="i2" v-for="(group, i2) in column">

                  <v-toolbar flat>
                    <v-toolbar-title>{{ group.name }}</v-toolbar-title>
                  </v-toolbar>
                  <v-card-text>
                    <template v-for="(item, i3) in group.items">

                      <v-text-field
                        v-if="item.type=='text'"
                        v-model="activeContact[item.field]"
                        :key="i3"
                        :label="item.label"
                        :readonly="item.readonly"
                        :disabled="item.disabled"
                        :data-qa="item.field"
                        :data-cy="item.field"
                        @change="dirty=true"
                      >
                      </v-text-field>

                      <v-checkbox
                        v-if="item.type=='checkbox'"
                        v-model="activeContact[item.field]"
                        :key="i3"
                        :label="item.label"
                        :readonly="item.readonly"
                        :disabled="item.disabled"
                        :data-qa="item.field"
                        :data-cy="item.field"
                        @change="dirty=true"
                      >
                      </v-checkbox>

                      <v-select
                        v-if="item.type=='select'"
                        v-model="activeContact[item.field]"
                        :key="i3"
                        :label="item.label"
                        :items="item.data()"
                        :readonly="item.readonly"
                        :disabled="item.disabled"
                        :data-qa="item.field"
                        :data-cy="item.field"
                        @change="dirty=true"
                      >
                      </v-select>

                      <v-combobox
                        v-if="item.type=='combobox'"
                        v-model="activeContact[item.field]"
                        :key="i3"
                        :label="item.label"
                        :items="item.data()"
                        :search-input.sync="search_company"
                        cache-items
                        :readonly="item.readonly"
                        :disabled="item.disabled"
                        :data-qa="item.field"
                        @change="dirty=true"
                      >
                      </v-combobox>

                    </template>
                  </v-card-text>
                </v-card>
              </v-flex>

            </v-layout>
            <v-sheet v-if="show.extraInfo">

              <v-card class="ma-2 mb-3">
                <v-card-text>
                  <v-layout wrap>

                    <template v-for="(filtered_field, idx) in filtered_fields">
                      <v-flex xs12 sm6 :key="idx" class="pl-2">

<v-sheet v-if="debug">{{ filtered_field.datatype }} - {{ filtered_field.id }}</v-sheet>
<v-sheet v-if="debug">{{ filtered_field.datatype=='catlist' ? activeContact.categories[filtered_field.id] : activeContact.customFields[filtered_field.id] }}</v-sheet>

                        <v-text-field
                            v-if="debug"
                          :label="filtered_field.label"
                          :value="filtered_field.datatype=='catlist' ? activeContact.categories[filtered_field.id] : activeContact.customFields[filtered_field.id]"
                          readonly
                          @click="onFocus(filtered_field)"
                          append-outer-icon="mdi-publish"
                          @click:append-outer="onFocus(filtered_field)"
                        >
                        </v-text-field>
                        <v-chip class="cat-chip" label outlined @click="onFocus(filtered_field)">
                          {{ filtered_field.label }}
                        </v-chip>
                        <br/>
                        <p class="cat-chips">
                          <template v-if="filtered_field.datatype === 'catlist'">
                            <template v-if="filtered_field.multiple === '1'">
                              <v-chip class="cat-chip" @click="onFocus(filtered_field)" v-for="cat of filtered_field.children.filter(a => activeContact.categories[filtered_field.id] && activeContact.categories[filtered_field.id].includes(a.id))" :key="cat.id">
                                {{ cat.name }}
                              </v-chip>
                              <br/>
                            </template>
                            <template v-else>
                              <v-chip class="cat-chip" @click="onFocus(filtered_field)">
                                {{ filteredFieldChildName(filtered_field) }}
                              </v-chip>
                              <br/>
                            </template>
                          </template>
                          <template v-else>
                            <v-chip class="cat-chip" @click="onFocus(filtered_field)">
                              {{ activeContact.customFields[filtered_field.id] }}
                            </v-chip>
                            <br/>
                          </template>
                        </p>

                      </v-flex>
                    </template>

                  </v-layout>
                </v-card-text>
              </v-card>

            </v-sheet>
            </template>
          </v-tab-item>
          <!-- Master Data - END-->

          <!--{{ 'CAT.length: ' + categories.length }}-->
          <!-- Categories -->
          <v-tab-item :transition="false" :reverse-transition="false">
            <template v-if="active===1">
            <v-layout fill-height v-if="show.categories">

              <v-flex>
                <v-card class="ma-2 mb-3">
                  <v-card-text>
                    <v-layout wrap>
                      <v-flex xs12 sm6 v-for="(category, idx) in filteredCategories" :key="idx" class="pl-2 pr-2">

<v-sheet v-if="debug">{{ category.id }}</v-sheet>
<v-sheet v-if="debug">{{ activeContact.categories[category.id] }}</v-sheet>

                        <v-text-field
                            :label="category.label"
                            :hint="category.desc"
                            :value="categoryNames(category.id)"
                            :readonly="true"
                            @click="onHitCategory(category.id)"
                            :ref="'c'+category.id"
                        >
                        </v-text-field>

                        <!--<v-autocomplete-->
                          <!--:multiple="category.multiple === '1'"-->
                          <!--v-model="activeContact.categories[category.id]"-->
                          <!--:label="category.label"-->
                          <!--:items="category.children"-->
                          <!--item-value="id"-->
                          <!--item-text="name"-->
                          <!--:readonly="category.readonly"-->
                          <!--:disabled="category.disabled"-->
                          <!--:data-qa="'c'+category.id"-->
                          <!--:ref="'c'+category.id"-->
                          <!--:menu-props="{ auto: true, closeOnContentClick: true, closeDelay: 400 }"-->
                          <!--@change="dirty=true"-->
                        <!--&gt;-->
                        <!--</v-autocomplete>-->

                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>

            </v-layout>
            </template>
          </v-tab-item>
          <!-- Categories - END-->


          <!-- Custom fields -->
          <v-tab-item :transition="false" :reverse-transition="false">
            <template v-if="active===2">
            <v-layout fill-height v-if="show.customFields">

              <v-flex>
                <v-card class="ma-2 mb-3">
                  <v-card-text>
                    <v-layout wrap>
                      <v-flex xs12 sm6 v-for="(custom_field, idx) in filteredFields" :key="idx" class="pl-2 pr-2">

<v-sheet v-if="debug">{{ custom_field }}</v-sheet>

                        <v-text-field
                          :label="custom_field.label"
                          v-model="activeContact.customFields[custom_field.id]"
                          :ref="'f'+custom_field.id"
                          :data-qa="'f'+custom_field.id"
                          :hint="custom_field.desc"
                          persistent-hint
                          @change="dirty=true"
                        >
                        </v-text-field>

                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>

            </v-layout>
            </template>
          </v-tab-item>
          <!-- Custom fields - END -->

          <!-- Notes -->
          <v-tab-item :transition="false" :reverse-transition="false">
            <template v-if="active===3">
            <v-layout fill-height>

              <v-flex>
                <v-card class="ma-2 mb-3">
                  <v-card-text>
                    <v-btn fab text absolute right small color-="grey lighten-3" @click="onCopyNotices()" :title="$t('CONTACT_NOTE_TO_CLIPBOARD_TT')"><v-icon>mdi-clipboard-text-outline</v-icon></v-btn>
                    <v-layout wrap>
                      <v-flex xs12 sm6 class="pl-2 pr-2">
                        <v-text-field :label="$t('DB_SUID')" :value="activeContact.suid" readonly></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 class="pl-2 pr-2">
                        <v-text-field :label="$t('CONTACT_ACCOUNT_NAME')" :value="activeContact.accountName" readonly></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 class="pl-2 pr-2">
                        <v-text-field :label="$t('CONTACT_CREATED')" :value="moment(activeContact.createdDateTime, $t('LOCALE_DATETIME_FORMAT')) + ' (' + activeContact.creator + ')'" readonly></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 class="pl-2 pr-2" v-if="activeContact.modified">
                        <v-text-field :label="$t('CONTACT_MODIFIED')" :value="moment(activeContact.modifiedDateTime, $t('LOCALE_DATETIME_FORMAT')) + ' (' + activeContact.modifier + ')'" readonly></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm12 class="pl-2 pr-2" v-if="activeContact.mergedSUIDInfo">
                        <v-textarea :label="$t('CONTACT_NOTES_MERGED_SUIDS')" :value="activeContact.mergedSUIDInfo" readonly></v-textarea>
                      </v-flex>
                    </v-layout>
                    <v-sheet>

                    </v-sheet>
                  </v-card-text>
                </v-card>

                <v-card class="ma-2 mb-3">
                  <v-card-text v-if="activeContact.id">
                    <v-sheet>
                      <v-btn text @click="createNotice = ''"><v-icon>mdi-plus-circle-outline</v-icon>&nbsp;{{ $t('CONTACT_NOTE_NEW') }}</v-btn>
                      <v-btn text @click="onCreateResubmission()"><v-icon>mdi-plus-circle-outline</v-icon>&nbsp;{{ $t('CONTACT_NOTE_NEW_RESUB') }}</v-btn>
                    </v-sheet>
                    <v-sheet v-if="createNotice !== null" class="pa-1" color="grey lighten-4" elevation="2">
                      <v-layout>
                        <v-flex xs12 sm6 md2 class="pl-2 pr-2">
                        </v-flex>
                        <v-flex xs12 sm6 md8 class="pl-2 pr-2">
                          <v-textarea v-model="createNotice" id="noteText0" auto-grow></v-textarea>
                        </v-flex>
                        <v-flex xs12 md2 class="pl-2 pr-2 text-xs-right">
                          <v-btn text icon @click="addLink.open(null)" :title="$t('LINK_TA_BUTTON_TT')"><v-icon>mdi-link-variant</v-icon></v-btn>
                          <v-btn text icon @click="onCreateNotice()" :title="$t('CONTACT_NOTE_SAVE_TT')"><v-icon>mdi-floppy</v-icon></v-btn>
                          <v-btn text icon @click="createNotice = null" :title="$t('CONTACT_NOTE_UNDO_TT')"><v-icon>mdi-undo-variant</v-icon></v-btn>
                        </v-flex>
                      </v-layout>
                    </v-sheet>
                    <v-sheet v-for="(note, idx) in noticesAndResubmissions" :key="`n${idx}`" class="pa-1 mt-2" :color="(note._type === 'resubmission' ? 'yellow' : 'grey') + ' lighten-4'" :elevation="editNote.id === note.id ? 2 : 0">

<v-sheet v-if="debug">{{ note }}</v-sheet>

                      <v-layout wrap>
                        <v-toolbar flat dense color="yellow lighten-4" v-if="note._type === 'resubmission'">
                          <v-icon>mdi-clock-outline</v-icon>&nbsp;{{ $t('CONTACT_NOTES_RESUB_LABEL', [note.owner_name]) }}
                          <v-spacer />
                          <span>{{ dateToISODate(note.resub_date) | moment($t('LOCALE_DATE_FORMAT')) }}</span>
                          <v-divider vertical inset class="ml-2 mr-2" />
                          <v-checkbox
                            :value="!note.active"
                            label="done?"
                            hide-details
                            style="display: contents;"
                            :disabled="note.creator_id !== user_id && (note._type !== 'resubmission' || note.owner_id !== user_id)"
                            @change="onDoneResubmission(note)"
                          ></v-checkbox>
                        </v-toolbar>
                        <v-flex xs12 sm6 md2 class="pl-2 pr-2">
                          <v-list>
                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-title>{{ note.created | moment($t('LOCALE_DATETIME_FORMAT_SHORT')) }}</v-list-item-title>
                                <v-list-item-subtitle>{{ note.creator_name }}</v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                            <template v-if="note.modified.getTime() != note.created.getTime()">
                              <v-divider />
                              <v-subheader>modified</v-subheader>
                              <v-list-item>
                                <v-list-item-content>
                                  <v-list-item-title>{{ note.modified | moment($t('LOCALE_DATETIME_FORMAT_SHORT')) }}</v-list-item-title>
                                  <v-list-item-subtitle>{{ note.modifier_name }}</v-list-item-subtitle>
                                </v-list-item-content>
                              </v-list-item>
                            </template>
                          </v-list>
                        </v-flex>
                        <v-flex xs12 sm6 md8 class="pl-2 pr-2">
                          <v-textarea :id="'noteText' + note.id" v-model="note.text" :readonly="editNote.id !== note.id" auto-grow></v-textarea>
                        </v-flex>
                        <v-flex v-if="note.creator_id === user_id || (note._type === 'resubmission' && note.owner_id === user_id)" xs12 md2 class="pl-2 pr-2 text-xs-right">
                          <span v-if="editNote.id !== note.id">
                            <v-btn text icon @click="onEditNote(note)" :title="$t('CONTACT_NOTE_EDIT_TT')"><v-icon>mdi-pencil-outline</v-icon></v-btn>
                            <v-btn text icon @click="onDeleteNote(note)" :title="$t('CONTACT_NOTE_DELETE_TT')"><v-icon>mdi-trash-can-outline</v-icon></v-btn>
                          </span>
                          <span v-else>
                            <v-btn text icon @click="addLink.open(note)" :title="$t('LINK_TA_BUTTON_TT')"><v-icon>mdi-link-variant</v-icon></v-btn>
                            <v-btn text icon @click="onUpdateNote(note)" :title="$t('CONTACT_NOTE_SAVE_TT')"><v-icon>mdi-floppy</v-icon></v-btn>
                            <v-btn text icon @click="onUndoEditNote(note)" :title="$t('CONTACT_NOTE_UNDO_TT')"><v-icon>mdi-undo-variant</v-icon></v-btn>
                          </span>
                        </v-flex>
                      </v-layout>
                    </v-sheet>

                  </v-card-text>
                  <v-card-text v-else>
                    <v-alert type="warning" outlined :value="true">
                      {{ $t('CONTACT_NOTES_SAVE_FIRST') }}
                    </v-alert>
                  </v-card-text>
                </v-card>
              </v-flex>

            </v-layout>
            </template>
          </v-tab-item>
          <!-- Notes - END-->


          <template v-for="(custom_view, i1) in tabview">
            <v-tab-item :transition="false" :reverse-transition="false" :key="i1">
              <v-layout fill-height>

                <v-flex>
                  <v-card class="ma-2 mb-3">
                    <v-card-text>
                      <v-layout wrap>
                        <v-flex xs12 sm6 v-for="(field, i2) in custom_view.fields" :key="i2" class="pl-2 pr-2">

<v-sheet v-if="debug">{{ field }}</v-sheet>

                          <v-text-field
                            v-if="field.type === 'ff'"
                            :label="getCustomFieldById(field.id).label"
                            v-model="activeContact.customFields[field.id]"
                            :hint="getCustomFieldById(field.id).desc"
                            persistent-hint
                            @change="dirty=true"
                            :ref="'f'+field.id"
                          >
                          </v-text-field>

                          <v-text-field
                              v-if="field.type === 'cat'"
                              :label="getCategoryById(field.id).label"
                              :hint="getCategoryById(field.id).desc"
                              :value="categoryNames(field.id)"
                              :readonly="true"
                              @click="onHitCategory(field.id)"
                              :ref="'c'+field.id"
                          >
                          </v-text-field>

                          <!--<v-autocomplete-->
                            <!--v-if="field.type === 'cat'"-->
                            <!--:multiple="getCategoryById(field.id).multiple === '1'"-->
                            <!--v-model="activeContact.categories[field.id]"-->
                            <!--:label="getCategoryById(field.id).label"-->
                            <!--:items="getCategoryById(field.id).children"-->
                            <!--item-value="id"-->
                            <!--item-text="name"-->
                            <!--:readonly="getCategoryById(field.id).readonly"-->
                            <!--:disabled="getCategoryById(field.id).disabled"-->
                            <!--:data-qa="'c'+field.id"-->
                            <!--:ref="'c'+field.id"-->
                            <!--:menu-props="{ auto: true, closeOnContentClick: true, closeDelay: 400 }"-->
                            <!--@change="dirty=true"-->
                          <!--&gt;-->
                          <!--</v-autocomplete>-->

                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>

              </v-layout>
            </v-tab-item>
          </template>

        </v-tabs>
      </v-sheet>

    <Snackbar v-bind="snackbar" @close="snackbar.close()" />

    <Dialog ref="dialog" />

    <v-sheet v-show="false">
      <input ref="vcard" type="file" id="files" name="files[]" accept="text/x-vcard" />
      <!-- <output id="list"></output> -->
      <!-- <div id="byte_range"></div> -->
      <!-- <div id="byte_content"></div> -->
      <input ref="picture" type="file" id="pictures" name="pictures[]" accept="image/*" />
      <img ref='picture_output' src='' />
    </v-sheet>

    <v-dialog
      :value="addLink.show"
      scrollable
      max-width="480px"
      @input="addLink.close()"
    >
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t('LINK_TA_POPUP_TITLE') }}</span>
        </v-card-title>
        <v-card-text>

          <v-text-field
            v-model="addLink.altText"
            :label="$t('LINK_TA_POPUP_LABEL_TITLE')"
            @keyup.enter="$refs.linkUrl.focus()"
          ></v-text-field>
          <v-text-field
            ref="linkUrl"
            v-model="addLink.linkUrl"
            :label="$t('LINK_TA_POPUP_LABEL_LINK')"
            @keyup.enter="onAddLink()"
          ></v-text-field>

        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text color="primary" @click="onAddLink()">{{ $t('LINK_TA_POPUP_BTN_OK') }}</v-btn>
          <v-btn text @click="addLink.close()">{{ $t('GENERIC_CANCEL') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <CategorySelField ref="categorySel" @select="onCategorySel"></CategorySelField>

  </v-layout>
</template>

<script>
import Vue from 'vue'
import vCard from 'vcard-parser'
import { mapGetters } from 'vuex'
import { selectValues } from '../config/SelectValues'
import Snackbar from '../components/common/Snackbar'
import Dialog from './common/Dialog'
import Contact from '../services/Contact'
import Resubmission from '../services/Resubmission'
import Search from '../services/Search'
import Data from '../services/Data'
import { dateToISODate, dateToCompact } from '../helpers/filters'
import _ from 'lodash'
import CategorySelField from "./CategorySelField";


export default {
  name: 'ContactForm',
  components: {
    CategorySelField,
    Snackbar,
    Dialog
  },
  props: ['contact_id', 'refToolbar'],
  data () {
    return {
      categoryDlg: false,
      masterTab: true,
      categoriesTab: true,
      fieldsTab: true,
      notesTab: true,

      debug: false,
      dirty: false,
      activeIndex: 0,
      rules: {
        required: value => !!value || 'Required.',
        email: value => {
          const pattern = /^(?:(?:[a-zäöü\d.!#$%&’*+/=?^_`{|}~-]+@[a-zäöü\d-]+(?:\.[a-zäöü\d-]+)*|"?([a-zäöü]| (?! ))+"? <[a-zäöü\d.!#$%&’+/=?^_`{|}~-]+@[a-z\d-]+(?:\.[a-z\d-]+)*>)(?:,\s*|$))*$/i
          return pattern.test(value) || 'Invalid e-mail.'
        }
      },
      drawer: true,
      mini: true,
      right: null,
      active: null,
      editNote: {
        id: null,
        text: null,
      },
      createNotice: null,
      // def_select_values: require('../config/select_values.json'), // computed
      search_company: null,
      show: {
        extraInfo: false,
        categories: false,
        customFields: false,
      },
      snackbar: {
        visible: false,
        color: null,
        text: null,
        timeout: null,
        action: {
          label: null,
          callback: null
        },
        show(args) {
          if (this.visible) {
            this.close()
            // call self in 100 ms
            setTimeout(() => {
              this.show(args)
            }, 100)
          } else {
            this.open(args)
          }
        },
        open({color, text, timeout, action}) {
          this.color = color
          this.text = text
          this.timeout = timeout
          this.action = action
          this.visible = true
        },
        close() {
          this.visible = false
        }
      },
      addLink: {
        note: null,
        show: false,
        start: 0,
        end: 0,
        altText: '',
        linkUrl: '',
        open(note) {
          this.note = note
          this.show = true
        },
        clear() {
          this.note = null
          this.altText = ''
          this.linkUrl = ''
        },
        close() {
          this.clear()
          this.show = false
        }
      },
      loadingContactData: false,
      reg_photo: 1,
    }
  },
  computed: {
    ...mapGetters(['isDebug', 'appCrmUrl', 'user_id', 'getAccounts', 'countries', 'categories',
     'categoryDict', 'custom_fields', 'tabview', 'getCustomFieldById', 'getCategoryById', 'activeContact',
     'companyItems', 'contactItems', 'contactsTotal', 'shouldReloadData', 'exportIds', 'allToExport',
     ]),
    filteredCategories() {
      const categoryIds = []
      this.tabview.forEach(tab => {
        categoryIds.push(...tab.fields.filter(f => f.type === 'cat').map(f => f.id))
      })
      // console.log('FILTERED_CATEGORIES.categoryIds:', categoryIds)
      const numrows = this.categories.filter( c => !categoryIds.includes(c.id))
      // console.log('FILTERED_CATEGORIES:', numrows)
      // console.log('FILTERED_FIELDS.this.custom_fields:', this.categories.map( c => [c.id, c.label] ))
      return numrows
    },
    filteredFields() {
      const fieldIds = []
      this.tabview.forEach(tab => {
        fieldIds.push(...tab.fields.filter(f => f.type === 'ff').map(f => f.id))
      })
      // console.log('FILTERED_FIELDS.fieldIds:', fieldIds)
      const numrows = this.custom_fields.filter( c => !fieldIds.includes(c.id))
      // console.log('FILTERED_FIELDS:', numrows)
      // console.log('FILTERED_FIELDS.this.custom_fields:', this.custom_fields)

      return numrows
    },
    def_select_values() { return selectValues.get(this) },
    master_data() {
      return [
        [
          {
            name: this.$t('CONTACT'),
            items: [
              { name: 'id', label: this.$t('DB_ID'), type: 'text', readonly: true, field: 'id' },
              { name: 'gender', label: this.$t('DB_GENDER'), type: 'select', data: () => this.def_select_values.gender, field: 'genderLabel' },
              { name: 'title', label: this.$t('DB_TITLE'), type: 'text', field: 'title' },
              { name: 'title2', label: this.$t('DB_TITLE2'), type: 'text', field: 'title2' },
              { name: 'name', label: this.$t('DB_LASTNAME'), type: 'text', field: 'lastname' },
              { name: 'first_name', label: this.$t('DB_FIRSTNAME'), type: 'text', field: 'firstname' },
              { name: 'second_name', label: this.$t('DB_SECONDNAME'), type: 'text', field: 'secondname' },
              { name: 'phone', label: this.$t('DB_PHONE'), type: 'text', field: 'phone' },
              { name: 'fax', label: this.$t('DB_FAX'), type: 'text', field: 'fax' },
              { name: 'mobile_extension', label: this.$t('DB_MOBILE'), type: 'text', field: 'mobile' },
              { name: 'email', label: this.$t('DB_EMAIL'), type: 'text', field: 'email' },

              { name: 'newsletter', label: this.$t('DB_NEWSLETTER'), type: 'checkbox', field: 'newsletter' },
              { name: 'bounced', label: this.$t('DB_BOUNCED'), type: 'checkbox', field: 'bounced' },
            ]
          },
        ],
        [
          {
            name: this.$t('CONTACT_CORPORATE'),
            items: [
              { name: 'company', label: this.$t('DB_COMPANY'), type: 'combobox', data: () => this.companyItems, field: 'company' },
              { name: 'company2', label: this.$t('DB_COMPANY2'), type: 'text', field: 'company2' },
              { name: 'company3', label: this.$t('DB_COMPANY3'), type: 'text', field: 'company3' },
              { name: 'company4', label: this.$t('DB_COMPANY4'), type: 'text', field: 'company4' },
              { name: 'position', label: this.$t('DB_POSITION'), type: 'text', field: 'position' },
              { name: 'division', label: this.$t('DB_DIVISION'), type: 'text', field: 'division' },
              { name: 'webpage', label: this.$t('DB_HOMEPAGE'), type: 'text', field: 'homepage' },
            ],
          },
          {
            name: this.$t('CONTACT_ADDRESS'),
            items: [
              { name: 'street', label: this.$t('DB_STREET'), type: 'text', field: 'street' },
              { name: 'street2', label: this.$t('DB_STREET2'), type: 'text', field: 'street2' },
              { name: 'street3', label: this.$t('DB_STREET3'), type: 'text', field: 'street3' },
              { name: 'street4', label: this.$t('DB_STREET4'), type: 'text', field: 'street4' },
              { name: 'house_no', label: this.$t('DB_HOUSE_NO'), type: 'text', field: 'house_no' },
              { name: 'zip_street', label: this.$t('DB_ZIPSTREET'), type: 'text', field: 'zipStreet' },
              { name: 'pobox', label: this.$t('DB_POBOX'), type: 'text', field: 'poBox' },
              { name: 'zip_pobox', label: this.$t('DB_ZIPPOBOX'), type: 'text', field: 'zipPoBox' },
              { name: 'city', label: this.$t('DB_CITY'), type: 'text', field: 'city' },
              { name: 'city2', label: this.$t('DB_CITY2'), type: 'text', field: 'city2' },
              { name: 'region', label: this.$t('DB_REGION'), type: 'text', field: 'region' },
              { name: 'country', label: this.$t('DB_COUNTRY'), type: 'select', data: () => this.countries, field: 'country' },
              // TODO: Change COUNTRY to autoselect: fix 'autocomplete' function for all !!!
            ]
          },
        ]
      ]
    },
    fields() {
      let fields = []
      fields.push(...this.categories
        .map(a => ({ ...a, value: `c${a.value}`})) // alter value so the v-select/v-autocomplete component can show all items (prevent duplicate IDs)
      )
      fields.push(...this.custom_fields
        .map(a => ({ ...a, value: `f${a.value}`})) // alter value so the v-select/v-autocomplete component can show all items (prevent duplicate IDs)
      )
      return fields.sort((a, b) => ('' + a.label).localeCompare(b.label))
    },
    filtered_fields() {
      return this.fields.filter(a => (
        (a.datatype === 'catlist' && _.has(this.activeContact.categories, a.id))
        || (a.datatype === 'free' && _.has(this.activeContact.customFields, a.id))
      ))
    },
    noticesAndResubmissions() {
      return this.activeContact.notices
        .map(a => ({ ...a, _type: 'notice' }))
        .concat(this.activeContact.resubmissions
          .map(a => ({ ...a, _type: 'resubmission' })))
        // .sort((a, b) => b.modified.getTime() - a.modified.getTime())
        .sort((a, b) => b.created.getTime() - a.created.getTime())
    },
    activeContactRegPhoto() {
      if (this.activeContact.pictures && this.activeContact.pictures.length && this.reg_photo) {
        let reg_photo = this.activeContact.pictures.find(a => a.purpose === 'reg_photo' && a.content != '')
        if (reg_photo) {
          return `data:${reg_photo.mimetype};base64,${reg_photo.content}`
        }
      }
      return ''
    },
    marked: {
      get() {
        const isSelected = (this.allToExport && !this.exportIds.includes(this.activeContact.id) || !this.allToExport && this.exportIds.includes(this.activeContact.id))

        return isSelected
      },
      set(isSelected) {
        const item = this.activeContact
        if (this.allToExport) {
          if (isSelected) {
            // OUT
            this.exportIds.splice(this.exportIds.findIndex(a => a.id == item.id),1)
          } else {
            //  IN
            this.exportIds.push(item.id)
          }
        } else {
          if (isSelected) {
            // IN
            this.exportIds.push(item.id)
          } else {
            // OUT
            this.exportIds.splice(this.exportIds.findIndex(a => a.id == item.id),1)
          }
        }
      }
    },
  },
  watch: {
    search_company(val) {
      if (!this.activeContact.company || val !== this.activeContact.company) {
        new Search(this.$api).company_search(val)
      }
    },
    activeContact() {
      if (this.contact_id == 'new') {
        this.activeContact.newsletter = 1
        this.active = 0
      }
      this.dirty = false
    },
    contact_id() {
// console.log('ContactForm: watch: contact_id: ', val)
      this.setupActiveContact()
    },
  },
  mounted() {
    this.refToolbar.$el.parentElement.appendChild(this.$refs.aToolbar.$el)
    // postpone loading of Tab Items contents
    setTimeout(() => { this.show.extraInfo = true }, 400)
    setTimeout(() => { this.show.categories = true }, 800)
    setTimeout(() => { this.show.customFields = true }, 1200)

    this.setupActiveContact()

    // restore Tab
    this.active = this.$route.query.tab;

    document.getElementById('files').addEventListener('change', this.handleFileSelect, false)
    document.getElementById('pictures').addEventListener('change', this.handlePictureSelect, false)
  },
  methods: {
    onCategorySel({categoryId, categById}) {
      Vue.set(this.activeContact.categories, categoryId, categById)
      this.$store.commit('setActiveContact', this.activeContact)
      this.dirty = true;
    },
    onHitCategory(categoryId) {
      const categById = this.activeContact.categories[categoryId]
      this.$refs.categorySel.onOpen(categoryId, categById)
    },
    categoryNames(categoryId) {
      if (this.activeContact && this.activeContact.categories && this.activeContact.categories[categoryId]) {
        if (Array.isArray(this.activeContact.categories[categoryId])){
          return this.activeContact.categories[categoryId].map( id => this.categoryDict[id].name )
        } else {
          const cat = this.activeContact.categories[categoryId]
          if (cat){
            if (this.categoryDict[cat]) {
              return [this.categoryDict[cat].name]
            } else {
              console.log("🚀 ~ file: ContactForm.vue ~ line 861 ~ categoryNames ~ cat", cat, this.categoryDict)
              return ['']
            }
          }
        }
      } else {
        return []
      }
    },
    setupActiveContact() {
      const activeIndex = this.contactItems.findIndex(a => a.id === this.contact_id)
      if (activeIndex >= 0) {
        this.activeIndex = activeIndex
        const activeContact = this.contactItems[this.activeIndex]
// console.log('updateActiveContact activeContact: ', activeContact)
        this.$store.commit('setActiveContact', activeContact)
      }
      new Contact(this.$api).load(this.contact_id)
        .then(() => {
          if (this.shouldReloadData) {
            this.loadingContactData = true
            new Data(this.$api).reInit()
              .then(() => {
                new Contact(this.$api).load(this.contact_id)
                  .then(() => {
                    this.loadingContactData = false
                  })
              })
          }
        })
    },
    onCopyNotices() {
      // let message = `${this.activeContact.firstname} ${this.activeContact.lastname} (${this.activeContact.accountID}) // Jira #142
      let message = `${this.activeContact.firstname} ${this.activeContact.lastname} (${this.activeContact.id})
${this.$t('DB_SUID')}: ${this.activeContact.suid}
${this.$t('CONTACT_ACCOUNT_NAME')}: ${this.activeContact.accountName}
${this.$t('CONTACT_CREATED')}: ${this.$moment(this.activeContact.createdDateTime).format(this.$t('LOCALE_DATETIME_FORMAT'))} (${this.activeContact.creator})
${this.$t('CONTACT_MODIFIED')}: ${this.$moment(this.activeContact.modifiedDateTime).format(this.$t('LOCALE_DATETIME_FORMAT'))} (${this.activeContact.modifier})
${this.$t('CONTACT_NOTES_MERGED_SUIDS')}: ...
`
      for (let notice of this.activeContact.notices) {
        message += `- - - - - - - - - - -\n`
        if (notice.modified.getTime()!=notice.created.getTime()) {
          message += `${this.$moment(notice.modified).format(this.$t('LOCALE_DATETIME_FORMAT_SHORT'))} (${notice.modifier_name})\n`
        } else {
          message += `${this.$moment(notice.created).format(this.$t('LOCALE_DATETIME_FORMAT_SHORT'))} (${notice.creator_name})\n`
        }
          message += `${notice.text}\n`
      }
      let that = this
      this.$copyText(message).then(() => {
        that.snackbar.show({ text: this.$t('CONTACT_NOTES_CLIPBOARD_OK_SB'), color: 'info' })
      }, error => {
        that.snackbar.show({ text: this.$t('CONTACT_NOTES_CLIPBOARD_ERROR_SB'), color: 'error' })
        console.error(error)
      })
    },
    onFocus(filtered_field) {
      // const tab = this.tabview.filter(tab => tab.fields.map(b => b.id).includes(filtered_field.id));
      let tab = []
      // eslint-disable-next-line no-console
      console.log('filtered_field:', filtered_field)
      this.tabview.forEach(t => {
        // eslint-disable-next-line no-console
        // console.log('TAB:', t)
        let fieldIds = []
        t.fields.forEach(f => {
          if (f.type==='ff' && filtered_field.datatype==='free') {
            fieldIds.push(f.id)
          } else
          if (f.type==='cat' && filtered_field.datatype==='catlist') {
            fieldIds.push(f.id)
          }
        })
        const hasId = fieldIds.includes(filtered_field.id)
        if (hasId) {
          tab.push(t)
        }
      })
      if (tab) {
        if (tab.length) {
          this.active = 4 + parseInt(tab[0].position, 10);
        } else {
          this.active = ((filtered_field.datatype === 'catlist') ? 1 : 2)
        }
        const self = this
        setTimeout(() => {
          const strId = (filtered_field.datatype === 'catlist' ? 'c' : 'f') + filtered_field.id
          const refId = self.$refs[strId]
          if (refId) {
            refId[0].focus()
          } else {
            // eslint-disable-next-line no-console
            console.error('CAT or FIELD missing: ', strId)
          }
        }, 800)
      }
    },
    onCopy() {
      const row1 = `${this.activeContact.title} ${this.activeContact.firstname} ${this.activeContact.lastname}`.trim()
      const row2 = `${this.activeContact.street} ${this.activeContact.house_no}`.trim()
      const row3 = `${this.activeContact.zipStreet} ${ this.activeContact.city }`.trim()
      const row4 = `${this.activeContact.phone}`.trim()
      const row5 = `${this.activeContact.email}`.trim()
      let message = `${row1}
${row2}
${row3}
${row4}
${row5}
`
      let that = this
      this.$copyText(message).then(() => {
        that.snackbar.show({ text: this.$t('CONTACT_CLIPBOARD_OK_SB'), color: 'info' })
      }, error => {
        that.snackbar.show({ text: this.$t('CONTACT_CLIPBOARD_ERROR_SB'), color: 'error' })
        console.error(error)
      })
    },
    onDuplicate() {
      this.activeContact.id = null
      this.activeContact._duplicating = true
    },
    onSave() {
// console.log('onSave', this.activeContact)
      if (this.activeContact.id < 1 && this.activeContact.lastname == '' && this.activeContact.firstname == '' && this.activeContact.email == '' && this.activeContact.company == '') {
				return;
			}
      this.$store.commit('setActiveContact', this.activeContact)
      if (!this.activeContact.id) {
        new Contact(this.$api).create()
          .then(() => {
            this.dirty = false
            const title = this.activeContact.firstname+' '+this.activeContact.lastname
            this.$router.replace({name: 'contact.edit', params: {contact_id: this.activeContact.id, title: title }, hash: this.getNewHash()})
          })
      } else {
        new Contact(this.$api).update()
          .then(data => {
            this.dirty = false
            const activeIndex = this.contactItems.findIndex(a => a.id === this.activeContact.id)
            if (data && data.aitem) {
              this.activeContact.mapAitemModified(data.aitem);
            }
            this.contactItems[activeIndex] = this.activeContact
            this.$store.commit('setContactItems', this.contactItems)
          })
      }
    },
    onDelete() {
      this.$refs.dialog.show({
        type: '',
        title: this.$t('GENERIC_DELETE_ALERT_TITLE'),
        message: this.$t('CONTACT_DELETE_ALERT'),
        query: {
          deleteAccounts: {
            type: 'checkbox',
            label: this.$t('CONTACT_DELETE_ACCOUNTS'),
          }
        },
        buttons: [
          {
            label: this.$t('GENERIC_DELETE'),
            close: true,
            // default: true,
            danger: true,
            callback: res => {
              new Contact(this.$api).delete(this.activeContact.id, res.deleteAccounts.value)
                .then(() => {
                  this.dirty = false
                  this.$router.replace({name: 'mailings', hash: this.getNewHash()})
                })
            },
          },
          {
            label: this.$t('GENERIC_CANCEL'),
            close: true,
            // default: true,
            // callback: res => {},
          },
        ]
      })
    },
    onCreateNotice() {
      new Contact(this.$api).create_notice({aitem_id: this.activeContact.id, text: this.createNotice})
        .then(res => {
          // push to notices
          let notice = res.notice
          notice = {
            ...notice._attributes,
            created: notice._attributes.created ? new Date(`${notice._attributes.created.substr(0,4)}-${notice._attributes.created.substr(4,2)}-${notice._attributes.created.substr(6,2)} ${notice._attributes.created.substr(-8)}`) : '',
            modified: notice._attributes.modified ? new Date(`${notice._attributes.modified.substr(0,4)}-${notice._attributes.modified.substr(4,2)}-${notice._attributes.modified.substr(6,2)} ${notice._attributes.modified.substr(-8)}`) : '',
            text: notice._text
          }
          notice.creator_name = this.$store.getters.getAccountById(this.user_id).fullname
          this.activeContact.notices.unshift(notice)
          this.createNotice = null // close form
          this.onReload()
        })
    },
    onEditNote(note) {
      if (note._type === 'notice') {
        this.editNote.id = note.id
        this.editNote.text = note.text
      } else
      if (note._type === 'resubmission') {
        this.$refs.dialog.show({
          type: '',
          title: this.$t('RESUBMISSION_TITLE'),
          query: {
            for: {
              type: 'autocomplete',
              label: this.$t('CONTACT_NOTES_RESUB_POPUP_FOR'),
              items: this.getAccounts.map(a => ({value: a.id, text: `${a.fullname} (${a.email})`})).sort((a, b) => ('' + a.text).localeCompare(b.text)),
              value: note.owner_id,
            },
            date: {
              type: 'date-picker',
              label: this.$t('CONTACT_NOTES_RESUB_POPUP_DATE'),
              value: dateToISODate(note.resub_date),
            },
            comment: {
              label: this.$t('CONTACT_NOTES_RESUB_POPUP_TEXT'),
              value: note.text
            },
            done: {
              type: 'checkbox',
              label: this.$t('CONTACT_NOTES_RESUB_POPUP_DONE'),
              value: !note.active
            },
          },
          buttons: [
            {
              label: this.$t('GENERIC_SAVE'),
              close: true,
              default: true,
              callback: res => {
  // console.log(res)
                new Resubmission(this.$api).update({
                  id: note.id,
                  address_id: this.activeContact.id,
                  owner_id: res.for.value,
                  notice: res.comment.value,
                  resub_date: dateToCompact(res.date.value)+'00:00:00',
                  active: +!res.done.value
                })
                .then(res => {
                  // replace to resubmissions
                  let resubmission = res.resubmission
                  resubmission = {
                    ...resubmission._attributes,
                    created: resubmission._attributes.created ? new Date(`${resubmission._attributes.created.substr(0,4)}-${resubmission._attributes.created.substr(4,2)}-${resubmission._attributes.created.substr(6,2)} ${resubmission._attributes.created.substr(-8)}`) : '',
                    modified: resubmission._attributes.modified ? new Date(`${resubmission._attributes.modified.substr(0,4)}-${resubmission._attributes.modified.substr(4,2)}-${resubmission._attributes.modified.substr(6,2)} ${resubmission._attributes.modified.substr(-8)}`) : '',
                    text: resubmission._text
                  }
                  // resubmission.creator_name = this.$store.getters.getAccountById(this.user_id).fullname
                  const index = this.activeContact.resubmissions.findIndex(a => a.id === note.id)
                  if (index >= 0) {
                    this.activeContact.resubmissions[index] = resubmission
                  } else {
                    this.activeContact.resubmissions.unshift(resubmission)
                  }
                  this.onReload()
                })
              },
            },
            {
              label: this.$t('GENERIC_CANCEL'),
              close: true,
              // default: true,
              // callback: res => {},
            },
          ]
        })
      }
    },
    onUndoEditNote(note) {
      note.text = this.editNote.text
      this.editNote.id = null
    },
    onUpdateNote(note) {
      new Contact(this.$api).update_notice({
        notice_id: note.id,
        aitem_id: this.activeContact.id,
        text: note.text,
      })
      .then(res => {
        // replace to notices
        let notice = res.notice
        notice = {
          ...notice._attributes,
          created: notice._attributes.created ? new Date(`${notice._attributes.created.substr(0,4)}-${notice._attributes.created.substr(4,2)}-${notice._attributes.created.substr(6,2)} ${notice._attributes.created.substr(-8)}`) : '',
          modified: notice._attributes.modified ? new Date(`${notice._attributes.modified.substr(0,4)}-${notice._attributes.modified.substr(4,2)}-${notice._attributes.modified.substr(6,2)} ${notice._attributes.modified.substr(-8)}`) : '',
          text: notice._text
        }
        // notice.creator_name = this.$store.getters.getAccountById(this.user_id).fullname
        const index = this.activeContact.notices.findIndex(a => a.id === note.id)
        if (index >= 0) {
          this.activeContact.notices[index] = notice
        } else {
          this.activeContact.notices.unshift(notice)
        }
        this.onReload()
      })
      this.editNote.id = null
    },
    onDeleteNote(note) {
      this.$refs.dialog.show({
        type: '',
        title: this.$t('GENERIC_DELETE_ALERT_TITLE'),
        message: note._type === 'notice' ? this.$t('CONTACT_NOTE_DELETE_ALERT') : this.$t('RESUBMISSION_DELETE_ALERT'),
        buttons: [
          {
            label: this.$t('GENERIC_DELETE'),
            close: true,
            // default: true,
            danger: true,
            callback: () => {
              if (note._type === 'notice') {
                new Contact(this.$api).delete_notice({notice_id: note.id, aitem_id: this.activeContact.id})
                  .then(() => {
                    this.activeContact.notices = this.activeContact.notices.filter(a => a.id !== note.id)
                    this.onReload()
                  })
              } else
              if (note._type === 'resubmission') {
                new Resubmission(this.$api).delete({id: note.id})
                  .then(() => {
                    this.activeContact.resubmissions = this.activeContact.resubmissions.filter(a => a.id !== note.id)
                    this.onReload()
                  })
              }
            },
          },
          {
            label: this.$t('GENERIC_CANCEL'),
            close: true,
            // default: true,
            // callback: res => {},
          },
        ]
      })
    },
    onCreateResubmission() {
      this.$refs.dialog.show({
        type: '',
        title: this.$t('RESUBMISSION_TITLE'),
        query: {
          for: {
            type: 'autocomplete',
            label: this.$t('CONTACT_NOTES_RESUB_POPUP_FOR'),
            items: this.getAccounts.map(a => ({value: a.id, text: `${a.fullname} (${a.email})`})).sort((a, b) => ('' + a.text).localeCompare(b.text)),
          },
          date: {
            type: 'date-picker',
            label: this.$t('CONTACT_NOTES_RESUB_POPUP_DATE'),
          },
          comment: {
            label: this.$t('CONTACT_NOTES_RESUB_POPUP_TEXT'),
          },
          done: {
            type: 'checkbox',
            label: this.$t('CONTACT_NOTES_RESUB_POPUP_DONE'),
          },
        },
        buttons: [
          {
            label: this.$t('GENERIC_SAVE'),
            close: true,
            default: true,
            callback: res => {
// console.log(res)
              new Resubmission(this.$api).create({
                address_id: this.activeContact.id,
                owner_id: res.for.value,
                notice: res.comment.value,
                resub_date: dateToCompact(res.date.value)+'00:00:00',
                active: +!res.done.value
              })
              .then(res => {
                // push to notices
                let resubmission = res.resubmission
                resubmission = {
                  ...resubmission._attributes,
                  created: resubmission._attributes.created ? new Date(`${resubmission._attributes.created.substr(0,4)}-${resubmission._attributes.created.substr(4,2)}-${resubmission._attributes.created.substr(6,2)} ${resubmission._attributes.created.substr(-8)}`) : '',
                  modified: resubmission._attributes.modified ? new Date(`${resubmission._attributes.modified.substr(0,4)}-${resubmission._attributes.modified.substr(4,2)}-${resubmission._attributes.modified.substr(6,2)} ${resubmission._attributes.modified.substr(-8)}`) : '',
                  text: resubmission._text
                }
                resubmission.creator_name = this.$store.getters.getAccountById(this.user_id).fullname
                this.activeContact.resubmissions.unshift(resubmission)
                this.onReload()
              })
            },
          },
          {
            label: this.$t('GENERIC_CANCEL'),
            close: true,
            // default: true,
            // callback: res => {},
          },
        ]
      })
    },
    onDoneResubmission(note) {
      note.active = !note.active
      new Resubmission(this.$api).active({
        id: note.id,
        active: +note.active
      })
      .then(() => {
      })
    },
    moment(date, format) {
      return this.$moment(date).format(format)
    },
    onReload(force=false) {
      if (this.dirty && !force) {

        this.$refs.dialog.show({
          type: '',
          title: this.$t('GENERIC_UNSAVED_CHANGES_TITLE'),
          message: this.$t('GENERIC_UNSAVED_CHANGES'),
          buttons: [
            {
              label: this.$t('GENERIC_REFRESH'),
              close: true,
              default: true,
              callback: () => {
                new Contact(this.$api).load(this.contact_id)
              },
            },
            {
              label: this.$t('GENERIC_CANCEL'),
              close: true,
              // default: true,
              // callback: res => {},
            },
          ]
        })
      } else {
        new Contact(this.$api).load(this.contact_id)
      }
    },
    onPrev() {
// console.log('onPrev')
      this.onActive(this.activeIndex - 1)
    },
    onNext() {
// console.log('onNext')
      this.onActive(this.activeIndex + 1)
    },
    onActive(index) {
// console.log('onActive', index, this.contactItems.length)
      if (index >= 0 && index <= this.contactItems.length - 1) {
        this.activeIndex = index
        const activeContact = this.contactItems[this.activeIndex]
        const contact_name = activeContact.firstname+' '+activeContact.lastname
        this.$router.push({name: 'contact.edit', params: {contact_id: activeContact.id, title: contact_name}, query: {tab: this.active}, hash: this.getNewHash()} )
      }
    },
    onAddLink() {
      const addLink = '[[' + this.addLink.altText + (this.addLink.linkUrl ? '|' + this.addLink.linkUrl : '') + ']]'
      if (this.addLink.note === null) {
        const ta = document.getElementById('noteText0')
        this.createNotice = this.insertAtCursor(ta, addLink)
      } else {
        const index = this.activeContact.notices.findIndex(a => a.id === this.editNote.id)
        if (index >= 0) {
          const ta = document.getElementById('noteText' + this.editNote.id)
          this.activeContact.notices[index].text = this.insertAtCursor(ta, addLink)
        }
      }
      this.addLink.close()
    },
    insertAtCursor(domField, strInsert) {
      //IE support
      if (document.selection) {
        domField.focus();
        var sel = document.selection.createRange();
        sel.text = strInsert;
      }
      //MOZILLA and others
      else if (domField.selectionStart || domField.selectionStart == '0') {
        var startPos = domField.selectionStart;
        var endPos = domField.selectionEnd;
        domField.value = domField.value.substring(0, startPos)
          + strInsert
          + domField.value.substring(endPos, domField.value.length);
      } else {
        domField.value += strInsert;
      }
      return domField.value
    },
    handleFileSelect(evt) {
      var files = evt.target.files; // FileList object
      // files is a FileList of File objects. List some properties.
      for (var i = 0, f; i < files.length; i++) {
        f = files[i]
        if (f.type === 'text/x-vcard') {
          this.readFile(f)
        }
      }
    },
    readFile(file) {
      var start = 0;
      var stop = file.size - 1;
      var reader = new FileReader();
      let card = null
      const that = this
      // If we use onloadend, we need to check the readyState.
      reader.onloadend = (evt) => {
        if (evt.target.readyState == FileReader.DONE) { // DONE == 2
          // document.getElementById('byte_content').textContent = evt.target.result;
          card = vCard.parse(evt.target.result)
// console.log(card)
          // document.getElementById('byte_range').textContent =
          //     ['Read bytes: ', start + 1, ' - ', stop + 1,
          //     ' of ', file.size, ' byte file'].join('');
          that._mapCard(card)
          // TODO: add flag to Contact trigerring Contact.create_notice() on Contact.create()
          that.activeContact.notices.push({
            text: 'vCard Import'
          })
          that.dirty = true
        }
      };
      var blob = file.slice(start, stop + 1);
      reader.readAsBinaryString(blob);
    },
    handlePictureSelect(evt) {
      var pictures = evt.target.files; // FileList object
      for (var i = 0, f; i < pictures.length; i++) {
        f = pictures[i]
        // if (f.type === 'text/x-vcard') {
          this.readPicture(f)
        // }
      }
    },
    readPicture(picture) {
      var reader = new FileReader();
      let userPicture = null
      const that = this
      // If we use onloadend, we need to check the readyState.
      reader.onloadend = (evt) => {
        if (evt.target.readyState == FileReader.DONE) { // DONE == 2
          // document.getElementById('byte_content').textContent = evt.target.result;
          // this.$refs.picture_output.src = evt.target.result
          userPicture = evt.target.result.replace('data:'+picture.type+';base64,', '')
// console.log(userPicture)
          // document.getElementById('byte_range').textContent =
          //     ['Read bytes: ', start + 1, ' - ', stop + 1,
          //     ' of ', picture.size, ' byte picture'].join('');
          let reg_photo_idx = that.activeContact.pictures.findIndex(a => a.purpose === 'reg_photo' && a.content != '')
          const photo = { purpose: 'reg_photo', content: userPicture, mimetype: picture.type }
          if (reg_photo_idx >= 0) {
            that.activeContact.pictures[reg_photo_idx] = photo
          } else {
            that.activeContact.pictures.push(photo)
          }

          // TODO: add flag to Contact trigerring Contact.create_notice() on Contact.create()
          that.activeContact.notices.push({
            text: 'Picture upload'
          })
          this.reg_photo++
          // if (that.activeContact.id) {
          //   that.onSave()
          // } else {
            that.dirty = true
          // }
        }
      };
      // var blob = picture.slice(start, stop + 1);
      reader.readAsDataURL(picture);
    },
    pictureRemove() {
      let reg_photo_idx = this.activeContact.pictures.findIndex(a => a.purpose === 'reg_photo' && a.content != '')
      if (reg_photo_idx >= 0) {
        this.activeContact.pictures[reg_photo_idx].content = '';
        // this.activeContact.pictures.splice(reg_photo_idx, 1);
        this.reg_photo++
        // if (this.activeContact.id) {
        //   this.onSave()
        // } else {
          this.dirty = true
        // }
      }
    },
    filteredFieldChildName(filtered_field) {
      const childCategory = filtered_field.children
              ? filtered_field.children.find(a => a.id === this.activeContact.categories[filtered_field.id]) // this has been fixed already @ 24.09.2019
              : null
      return childCategory ? childCategory.name : ''
    },
    _mapCard(card) {
      if (card.org && card.org[0]) {
        if (!Array.isArray(card.org[0].value)) {
          card.org[0].value = [card.org[0].value]
        }

        if (card.org[0].value[0]) {
          this.activeContact.company = card.org[0].value[0]
        }
        if (card.org[0].value[1]) {
          this.activeContact.company2 = card.org[0].value[1]
        }
      }
      if (card.title && card.title[0]) {
        this.activeContact.position = card.title[0].value
      }
      if (card.tel) {
        for (let tel of card.tel) {
          if (this._hasMeta(tel, 'type', 'work')) {
            this.activeContact.phone = tel.value
          }
          if (this._hasMeta(tel, 'type', ['cell', 'work'])) {
            this.activeContact.mobile = tel.value
          }
          if (this._hasMeta(tel, 'type', ['fax', 'work'])) {
            this.activeContact.fax = tel.value
          }
        }
      }
      if (card.email && card.email[0] && this._hasMeta(card.email[0], 'type', 'work')) {
        this.activeContact.email = card.email[0].value
      }
      if (card.url && card.url[0] && this._hasMeta(card.url[0], 'type', 'work')) {
        this.activeContact.homepage = card.url[0].value
      }
      // Name: lastname;firstname;secondname;title
      if (card.n && card.n[0]) {
        if (!Array.isArray(card.n[0].value)) {
          card.n[0].value = [card.n[0].value]
        }
        if (card.n[0].value[0]) {
          this.activeContact.lastname = card.n[0].value[0]
        }
        if (card.n[0].value[1]) {
          this.activeContact.firstname = card.n[0].value[1]
        }
        if (card.n[0].value[2]) {
          this.activeContact.secondname = card.n[0].value[2]
        }
        if (card.n[0].value[3]) {
          this.activeContact.title = card.n[0].value[3]
        }
      }
      // Address: pobox;street2;street;city;state;zip;country
      if (card.adr && card.adr[0] && this._hasMeta(card.adr[0], 'type', 'work')) {
        for (let adr of card.adr) {
          if (!Array.isArray(adr.value)) {
            adr.value = [adr.value]
          }
          if (adr.value[0]) {
            this.activeContact.poBox = adr.value[0]
          }
          if (adr.value[1]) {
            this.activeContact.street2 = adr.value[1]
          }
          if (adr.value[2]) {
            this.activeContact.street = adr.value[2]
          }
          if (adr.value[3]) {
            this.activeContact.city = adr.value[3]
          }
          if (adr.value[4]) {
            //
          }
          if (adr.value[5]) {
            this.activeContact.zipStreet = adr.value[5]
          }
          if (adr.value[6]) {
            const country = this.countries.find(a => a.name === adr.value[6])
            this.activeContact.country = country ? country.iso_code : adr.value[6]
          }
        }
      }
      if (card.photo && card.photo[0] && this._hasMeta(card.photo[0], 'value', 'url')) {
        this.activeContact.imageURL = card.photo[0].value
      }
    },
    _hasMeta(item, meta, val) {
      val = Array.isArray(val) ? val : [val]
      return item.meta && item.meta[meta] && item.meta[meta].filter(a => val.every(b => a.toLowerCase().split(',').includes(b)))
    },
    // map global filter as local method so we can use it in templates as function
    dateToISODate(val) {
      return dateToISODate(val)
    },
    onLeave(next) {
      if (this.dirty) {

        next(false)
        this.$refs.dialog.show({
          type: '',
          title: this.$t('GENERIC_UNSAVED_CHANGES_TITLE'),
          message: this.$t('GENERIC_UNSAVED_CHANGES'),
          buttons: [
            {
              label: this.$t('GENERIC_SAVE'),
              close: true,
              default: true,
              callback: () => {
                this.onSave()
                next()
              },
            },
            {
              label: this.$t('GENERIC_DISCARD'),
              close: true,
              default: true,
              callback: () => {
                next()
              },
            },
            {
              label: this.$t('GENERIC_CANCEL'),
              close: true,
              // default: true,
              // callback: res => {},
            },
          ]
        })

      } else {
        next()
      }
    },
    appReload(e) {
      if (this.dirty) {
        e.preventDefault()
        e.returnValue = 'Please save' // Chrome only
        return 'Please save' // legacy
      }
    },
    maleAvatar() {
      return this.appCrmUrl + 'img/male-avatar.png'
    },
    femaleAvatar() {
      return this.appCrmUrl + 'img/female-avatar.png'
    },
    getNewHash() {
      const dt = new Date()
      return '##'+ (dt.getTime()*1000 + dt.getMilliseconds())
    }
  },
  beforeRouteUpdate(to, from, next) {
// console.log('beforeRouteUpdate')
    this.onLeave(next)
  },
  beforeRouteLeave(to, from, next) {
// console.log('beforeRouteLeave')
    this.onLeave(next)
  },
  beforeMount() {
    window.addEventListener('beforeunload', this.appReload)
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.appReload)
    this.$refs.aToolbar.$el.remove()
  },
}
</script>

<style>
.v-navigation-drawer,
.btn-debug.v-btn--floating.v-btn--absolute {
  z-index: 0;
}
.v-toolbar__items .v-input {
  /* -webkit-box-align: center; */
  /* -ms-flex-align: center; */
  align-items: center;
  /* -ms-flex-item-align: center; */
  align-self: center;
}

.contact-avatar {
  cursor: pointer;
}
.picture-wrapper {
  width: 48px;
  height: 48px;
  position: relative;
  display: inline-flex;
}
.picture-wrapper .picture-remove {
  position: absolute;
  top: -6px;
  right: -10px;
  display: none;
  opacity: 0.5;
  transition: opacity .2s ease;
}
.picture-wrapper:hover .picture-remove {
  display: block;
}
.picture-wrapper:hover .picture-remove:hover {
  opacity: 1;
}

.short-info p {
  margin: 0
}

.cat-chips {
  margin-top: 10px;
  margin-bottom: 20px;
  margin-left: 30px;
}

.cat-chip {
  margin-top: 2px;
  margin-bottom: 2px;
  margin-left: 2px;
  margin-right: 2px;
}
</style>
